import React from 'react'
import styles from './styles.css'
import contextUrl from '../../Root/contextUrl';
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import withMutation from 'react-apollo-decorators/lib/withMutation'

@withMutation(gql`
  mutation organizationImages($contextUrl: String!) {
    organizationImages(contextUrl: $contextUrl) 
  }
`)

export default class Logo extends React.Component {
  static propTypes = {
    organizationImages: PropTypes.func,
  }
  
  state = {
    logo: '../../../logo.png',
    tengoLogo: false,
    fetched: false
  }

  renderLogo(){
    if(this.state.tengoLogo){
      return(
          <img className={styles.logo} src={this.state.logo} alt="Logo" />
      )
    }
  }

  
  async fetchOrgImages(){
    this.setState({fetched:true})
    let resultado = await this.props.organizationImages({contextUrl: contextUrl})
    if(resultado && resultado.organizationImages){
      //console.log("Resultado fetchOrgImages:", resultado.organizationImages)
      this.setState({logo: resultado.organizationImages.logo,tengoLogo: true})
    } else {
      this.setState({tengoLogo: true})
    }
  }

  render() {

    if(!this.state.fetched){
      this.fetchOrgImages()
    }
    /*
    var context = contextUrl;
    if(context === 'pi.tufirma.digital' || context === 'test.tufirma.digital' || context === 'portalinmobiliario.tufirma.digital' ){
      this.setState({logo: '/logoportal.png'})
    }
    */
    return (
      <div className={styles.logoContainer}>
        {this.renderLogo()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Public/Logo.js